import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PermissionGuard from 'utils/route-guard/PermissionGuard';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Container, Toolbar } from '@mui/material';
import { openDrawer } from 'store/reducers/menu';

// project import
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import navigation from 'menu-items';
import useConfig from 'hooks/useConfig';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import FormAbsent from 'pages/absent';
import useAuth from 'hooks/useAuth';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  // const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));
  const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

  const { container, miniDrawer } = useConfig();
  const dispatch = useDispatch();

  const menu = useSelector((state) => state.menu);
  const { drawerOpen } = menu;
  const { user } = useAuth();

  // drawer toggler
  const [open, setOpen] = useState(!miniDrawer || drawerOpen);
  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  const [isOpenAbsent, setOpenAbsent] = useState(!user?.isAbsent);

  useEffect(() => {
    if (!matchDownMD) {
      setOpen(true);
      dispatch(openDrawer({ drawerOpen: true }));
    } else {
      setOpen(false);
      dispatch(openDrawer({ drawerOpen: false }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownMD]);

  // // set media wise responsive drawer
  // useEffect(() => {
  //   if (!miniDrawer) {
  //     setOpen(!matchDownLG);
  //     dispatch(openDrawer({ drawerOpen: !matchDownLG }));
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [matchDownLG]);

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerOpen]);

  return (
    <>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Header open={open} handleDrawerToggle={handleDrawerToggle} />
        <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
        <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
          <Toolbar />
          {container && (
            <Container
              maxWidth="lg"
              sx={{
                px: { xs: 0, sm: 2 },
                position: 'relative',
                minHeight: 'calc(100vh - 110px)',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} />
              <PermissionGuard>
                <Outlet />
              </PermissionGuard>
              <Footer />
            </Container>
          )}
          {!container && (
            <Box sx={{ position: 'relative', minHeight: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column' }}>
              {/* <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} /> */}
              <PermissionGuard>
                <Outlet />
              </PermissionGuard>
              <Footer />
            </Box>
          )}
        </Box>
      </Box>
      {isOpenAbsent && <FormAbsent open={isOpenAbsent} onClose={(event) => setOpenAbsent(!event)} />}
    </>
  );
};

export default MainLayout;
